import { useContext } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { Link } from 'react-router-dom';
import MyContext from '../context/MyContext';
import texts from '../services/texts';
import SwitchLinguage from './SwitchLinguage';

export default function BurgerMenu() {
  const { language } = useContext(MyContext);

  return (
    <Menu>
      <Link to="/">
        <p className="menu">Home</p>
      </Link>
      <Link to="/about">
        <p className="menu">{texts.menu[language].About}</p>
      </Link>
      <Link to="/projects">
        <p className="menu">{texts.menu[language].Projects}</p>
      </Link>
      <Link to="/contact">
        <p className="menu">{texts.menu[language].Contact}</p>
      </Link>
      <SwitchLinguage />
    </Menu>
  );
}
